import { render } from "./TronEdu.vue?vue&type=template&id=f1c19626"
import script from "./TronEdu.vue?vue&type=script&lang=js"
export * from "./TronEdu.vue?vue&type=script&lang=js"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__